import obaxios from '@/utils/obaxios'

// 获取所有的项目
const project_list = function () {
  return obaxios({
    method: 'get',
    url: '/task/utm_project/',
  })
}

// 获取管理员项目
const project_admin_list = function () {
  return obaxios({
    method: 'get',
    url: '/task/utm_project/',
    params: { admin: true },
  })
}

// 获取项目
const project_get = function ({ id }) {
  return obaxios({
    method: 'get',
    url: `/task/utm_project/${id}/`,
  })
}

// 创建项目
const project_create = function (data) {
  return obaxios({
    method: 'post',
    url: '/task/utm_project/',
    data: data,
    headers: { 'Content-Type': 'application/json' }
  })
}

// 更新项目
const project_update = function ({ id, data }) {
  return obaxios({
    method: 'patch',
    url: `/task/utm_project/${id}/`,
    data: data,
    headers: { 'Content-Type': 'application/json' }
  })
}

// 批量创建更新项目
const project_bulk_create_update = function (data) {
  return obaxios({
    method: 'post',
    url: '/task/utm_project/bulk_create_or_update/',
    data: data,
    headers: { 'Content-Type': 'application/json' }
  })
}

// 删除项目
const project_delete = function ({ id }) {
  return obaxios({
    method: 'delete',
    url: `/task/utm_project/${id}/`,
  })
}

// 批量删除
const project_bulk_delete = function (data) {
  return obaxios({
    method: 'post',
    url: '/task/utm_project/bulk_destroy/',
    data: data,
    headers: { 'Content-Type': 'application/json' }
  })
}

export { project_list, project_get, project_admin_list, project_create, project_update, project_bulk_create_update, project_delete, project_bulk_delete }
